import LicenseBuilderSortable from "../licenseBuilderSortable";
import License from "../license";
import Guid from "~/helpers/guid";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";

export default class PrerequisiteLicense extends LicenseBuilderSortable {
  prerequisite_license_id: string;
  prerequisite_license_title: string;
  is_only_required_for_initial: boolean;

  static repo: IRepo<PrerequisiteLicense> = new Repo<PrerequisiteLicense>('prerequisiteLicenses', PrerequisiteLicense);

  constructor(license: License) {
    super();
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('prerequisite_license_id', '');
    this.defineProperty('prerequisite_license_title', '');
    this.defineProperty('is_only_required_for_initial', false);
    this.defineProperty('sort_order', license.nextSortOrderFor(this.rootName));
    this.parent = license;
    this.license = license;
  }

  get rootName(): string {
    return 'prerequisite_licenses';
  }

  get displayName(): string {
    return 'Prerequisite Licenses';
  }
}